import React from 'react';
import { Card, Badge } from '../../index';

/**
 * StatusNode: Used for operational status cards
 */
export const StatusNode = ({ title, status, badgeVariant = 'success', description, icon, style }) => {
    return (
        <Card level={2} style={{ height: '100%', ...style }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        {icon && <div style={{ opacity: 0.6, color: 'var(--color-primary)' }}>{icon}</div>}
                        <h4 style={{ margin: 0, fontSize: '0.85rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                            {title}
                        </h4>
                    </div>
                    <Badge variant={badgeVariant} size="sm">{status}</Badge>
                </div>
                {description && (
                    <p style={{ margin: 0, fontSize: '0.9rem', opacity: 0.7, lineHeight: 1.5 }}>
                        {description}
                    </p>
                )}
            </div>
        </Card>
    );
};

/**
 * PropertyList: High-density key-value list
 */
export const PropertyList = ({ items, style }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem', ...style }}>
            {items.map((item, idx) => (
                <div key={idx} style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    paddingBottom: idx === items.length - 1 ? 0 : '1rem',
                    borderBottom: idx === items.length - 1 ? 'none' : '1px solid var(--color-border-light)'
                }}>
                    <span style={{
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        opacity: 0.5,
                        letterSpacing: '0.05em'
                    }}>
                        {item.label}
                    </span>
                    <span style={{
                        fontSize: '0.95rem',
                        fontWeight: 600,
                        textAlign: 'right'
                    }}>
                        {item.value}
                    </span>
                </div>
            ))}
        </div>
    );
};
